import { CoolHttp } from '@angular-cool/http';
import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { lastValueFrom } from 'rxjs';
import { GlobalCacheConfig } from 'ts-cacheable';
import { MINUTE_IN_MILLISECONDS } from '../../../../../common/utils/date.utils';
import { Environment } from '../../../environments/environment.interface';
import { SetIsInitializedAction } from '../../app.state';
import { AuthenticationService } from './authentications.service';
import { UnauthenticatedInterceptor } from './http/unauthenticated.interceptor';
import { ENVIRONMENT } from './injection-tokens';
import { LoggerService } from './logger/logger.service';
import { TrackingService } from './tracking.service';

GlobalCacheConfig.maxCacheCount = 1000;
GlobalCacheConfig.maxAge = 5 * MINUTE_IN_MILLISECONDS;

@Injectable()
export class StartupService {
  constructor(
    private _store: Store,
    private _authenticationService: AuthenticationService,
    @Inject(ENVIRONMENT) private _environment: Environment,
    private _loggerService: LoggerService,
    private _unauthenticatedInterceptor: UnauthenticatedInterceptor,
    private _http: CoolHttp,
    private _trackingService: TrackingService,
  ) {
  }

  public async setupAsync() {
    this._loggerService.initialize();

    this._setupHttp();

    await this._authenticationService.initializeAsync();

    this._trackingService.init();

    await lastValueFrom(this._store.dispatch(new SetIsInitializedAction()));
  }

  private _setupHttp() {
    this._http.registerBaseUrl(this._environment.serverUrl + '/api');
    this._http.setWithCredentials(true);

    this._http.registerResponseInterceptor(this._unauthenticatedInterceptor);
  }
}
